export default __webpack_public_path__ + "static/media/halcon-logo.bee99a79.png";